import { Link } from "react-router-dom";
import { getHead, PHONE, PHONE_TEL } from "../seo/routes";
import { Seo } from "../components/Seo";

export default function NotFound() {
  const head = getHead("/404");
  return (
    <>
      <Seo title={head.title} description={head.description} noindex />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center" data-testid="not-found-page">
        <p className="font-display text-7xl font-extrabold text-[#FF5500]">404</p>
        <h1 className="mt-4 font-display text-3xl font-bold uppercase tracking-tight text-white">Page Not Found</h1>
        <p className="mt-3 text-gray-400 max-w-md mx-auto">The page you are looking for doesn't exist. Explore our security services or reach dispatch directly.</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link to="/" data-testid="notfound-home-link" className="inline-flex items-center bg-[#FF5500] hover:bg-[#E04800] text-white font-semibold px-6 py-3 rounded-sm transition-colors">
            Back to Home
          </Link>
          <a href={PHONE_TEL} data-testid="notfound-phone-button" className="inline-flex items-center bg-white/5 hover:bg-white/10 border border-white/15 text-white font-medium px-6 py-3 rounded-sm transition-colors">
            {PHONE}
          </a>
        </div>
      </section>
    </>
  );
}
